<!-- <div *ngIf="shwDiv">
    <div class="grid grid-cols-1 lg:grid-cols-1 md:grid-cols-1 sm:grid-cols-1" *ngIf="addRvw">
        <div class="font-medium text-secondary w-full p-2 text-center">{{rvwData.rvw_qtn}} <span class="ml-2">
                <button mat-icon-button (click)="reviewClick(1)" [ngClass]="{'bg-gray-200': rvw_vle == 1}">
                    <mat-icon [svgIcon]="'heroicons_outline:thumb-up'" [ngClass]="{'text-primary-500': rvw_vle == 1}"
                        ></mat-icon>
                </button>
                <button mat-icon-button (click)="reviewClick(0)" [ngClass]="{'bg-gray-200': rvw_vle == 0}">
                    <mat-icon [svgIcon]="'heroicons_outline:thumb-down'" [ngClass]="{'text-red-500': rvw_vle == 0}"
                        ></mat-icon>
                </button>
            </span> </div>
        <div class="flex-row w-full sm:w-full p-2 text-center" >
            <mat-form-field appearance="fill">
                <textarea matInput [rows]="3" [placeholder]="'Write Your Suggestions'" [(ngModel)]="sgtn_tx"></textarea>
             </mat-form-field>
        </div>
        <div class="flex-row sm:w-full p-2 text-center">
            <button class="ml-auto sm:ml-0 m-2" mat-button (click)="Close()" *ngIf="edt_in ==1">
                Cancel
            </button>
            <button class="order-first sm:order-last" mat-flat-button [color]="'primary'" (click)="sbmt()" *ngIf="edt_in ==1">
                Update
            </button>
            <button class="order-first sm:order-last" mat-flat-button [color]="'primary'" (click)="sbmt()" *ngIf="edt_in ==0">
               Submit
            </button>
        </div>
    </div>
    <div *ngIf="shwPrvsRvw">
        <div class="grid grid-cols-1 lg:grid-cols-1 md:grid-cols-1 sm:grid-cols-1 text-center ">
            <div class="font-medium text-secondary w-full p-2">{{rvwData.rvw_qtn}}<span class="ml-2">
                    <button mat-icon-button [ngClass]="{'bg-gray-200': rvw_vle == 1}">
                        <mat-icon [svgIcon]="'heroicons_outline:thumb-up'" [ngClass]="{'text-primary-500': rvw_vle == 1}">
                        </mat-icon>
                    </button>
                    <button mat-icon-button [ngClass]="{'bg-gray-200': rvw_vle == 0}">
                        <mat-icon [svgIcon]="'heroicons_outline:thumb-down'" [ngClass]="{'text-red-500': rvw_vle == 0}">
                        </mat-icon>
                    </button>
                </span> 
                <mat-icon class="icon-size-4 cursor-pointer" style="float: right;" [svgIcon]="'heroicons_solid:pencil-alt'" (click)="edtCntct()"></mat-icon></div>
            <div class="flex-row w-full sm:w-full p-2 text-center">
                <mat-form-field appearance="fill">
                    <textarea matInput [rows]="3" [placeholder]="'Write Your Suggestions'" [(ngModel)]="sgtn_tx"></textarea>
               </mat-form-field>
            </div>
        </div>
    </div>
</div> -->

<!-- Button -->
<button mat-icon-button (click)="openPanel()" #shortcutsOrigin>
    <mat-icon [svgIcon]="'heroicons_outline:thumb-up'"></mat-icon>
</button>

<!-- Shortcuts panel -->
<ng-template #shortcutsPanel>
    <div
        class="fixed inset-0 sm:static sm:inset-auto flex flex-col sm:min-w-90 sm:w-90 sm:rounded-2xl overflow-hidden shadow-lg">

        <!-- Header -->

        <div class="relative flex flex-col flex-auto sm:max-h-120 -mb-px overflow-y-auto bg-card">

            <!-- Add/Edit mode -->
            <hr style="margin: 8px 0px 0px 0px;">
            <div class="grid grid-cols-1 lg:grid-cols-1 md:grid-cols-1 sm:grid-cols-1" *ngIf="addRvw">
                <div class="font-medium text-secondary w-full p-2 text-center">{{rvwData.rvw_qtn}} <span class="ml-2">
                        <button mat-icon-button (click)="reviewClick(1)" [ngClass]="{'bg-gray-200': rvw_vle == 1}">
                            <mat-icon [svgIcon]="'heroicons_outline:thumb-up'" [ngClass]="{'text-primary-500': rvw_vle == 1}"
                                ></mat-icon>
                        </button>
                        <button mat-icon-button (click)="reviewClick(0)" [ngClass]="{'bg-gray-200': rvw_vle == 0}">
                            <mat-icon [svgIcon]="'heroicons_outline:thumb-down'" [ngClass]="{'text-red-500': rvw_vle == 0}"
                                ></mat-icon>
                        </button>
                    </span> </div>
                <div class="flex-row w-full sm:w-full p-2 text-center" >
                    <mat-form-field appearance="fill">
                        <textarea matInput [rows]="3" [placeholder]="'Write Your Suggestions'" [(ngModel)]="sgtn_tx"></textarea>
                        <!-- <input matInput [placeholder]="'Write Your Suggestions'" [(ngModel)]="sgtn_tx"> -->
                    </mat-form-field>
                </div>
                <div class="flex-row sm:w-full p-2 text-center">
                    <button class="ml-auto sm:ml-0 m-2" mat-button (click)="Close()" *ngIf="edt_in ==1">
                        Cancel
                    </button>
                    <button class="order-first sm:order-last" mat-flat-button [color]="'primary'" (click)="sbmt()" *ngIf="edt_in ==1">
                        Update
                    </button>
                    <button class="order-first sm:order-last" mat-flat-button [color]="'primary'" (click)="sbmt()" *ngIf="edt_in ==0">
                       Submit
                    </button>
                </div>
            </div>
            <div *ngIf="shwPrvsRvw">
                <div class="grid grid-cols-1 lg:grid-cols-1 md:grid-cols-1 sm:grid-cols-1 text-center ">
                    <div class="font-medium text-secondary w-full p-2">{{rvwData.rvw_qtn}}<span class="ml-2">
                            <button mat-icon-button [ngClass]="{'bg-gray-200': rvw_vle == 1}">
                                <mat-icon [svgIcon]="'heroicons_outline:thumb-up'" [ngClass]="{'text-primary-500': rvw_vle == 1}">
                                </mat-icon>
                            </button>
                            <button mat-icon-button [ngClass]="{'bg-gray-200': rvw_vle == 0}">
                                <mat-icon [svgIcon]="'heroicons_outline:thumb-down'" [ngClass]="{'text-red-500': rvw_vle == 0}">
                                </mat-icon>
                            </button>
                        </span> 
                        <mat-icon class="icon-size-4 cursor-pointer" style="float: right;" [svgIcon]="'heroicons_solid:pencil-alt'" (click)="edtCntct()"></mat-icon></div>
                    <div class="flex-row w-full sm:w-full p-2 text-center">
                        <mat-form-field appearance="fill">
                            <textarea matInput [rows]="3" [placeholder]="'Write Your Suggestions'" [(ngModel)]="sgtn_tx"></textarea>
                            <!-- <input matInput [placeholder]="'Write Your Suggestions'" [(ngModel)]="sgtn_tx"> -->
                        </mat-form-field>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>